import { AscModalWithStepsPropsI } from "./AscModalWithSteps.type";
import styles from "./AscModalWithSteps.module.scss";
import AscModal from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";
import BackgroundDecoration from "../../assets/illustrations/background-decoration-2.svg";
import Icon from "../../assets/icons/check_active.svg";
import { WhiteDecorCornerBox } from "../AscIllustrations";
import AscLink from "../AscLink/AscLink";

function AscModalWithSteps({
  visible,
  setVisible,
  iconUrl = Icon,
  withIcon = true,
  title,
  description,
  stepsList,
  withButton,
  textButton,
  buttonActionPath,
}: AscModalWithStepsPropsI) {
  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      backgroundDecorationUrl={BackgroundDecoration}
    >
      <div className={styles.element}>
        {withIcon && <img className={styles.icon} src={iconUrl} alt={"icon"} />}
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}

        <div className={styles.list}>
          {stepsList.map((item, index) => (
            <div key={index + item} className={styles.listItem}>
              <div className={styles.listItemCounter}>{index + 1}</div>
              <div className={styles.listItemContent}>{item}</div>

              <WhiteDecorCornerBox className={styles.cornerDecor} />
            </div>
          ))}
        </div>

        {withButton && (
          <AscLink className={styles.button} href={buttonActionPath}>
            <AscButton variant={"secondary"}>{textButton}</AscButton>
          </AscLink>
        )}
      </div>
    </AscModal>
  );
}

export default AscModalWithSteps;
